module.exports = __webpack_public_path__ + "img/map.7de7881a.png";